import { apiUrls } from 'app/api.config';
import { SlimBanner } from 'app/components/SlimBanner';
import { useAppDispatch } from 'app/store';
import { syncVersionEffect } from 'app/store/Releases/effects';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useQueryParams } from 'app/components/SignUp/SignUpForm/hooks';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { Link } from 'types/api.types';
import { ReleaseType } from 'types/releases';
import { getReleaseGuidFromReleaseCallback } from './utils';

export const ReleaseCallback = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { guid: songGuid } = useParams();
  const queryParams = useQueryParams();

  const callback = queryParams.get('callback');
  const versionGuid = queryParams.get('versionGuid');
  const releaseGuid = getReleaseGuidFromReleaseCallback(callback);
  const releaseType = queryParams.get('releaseType');

  if (callback && songGuid && releaseGuid && versionGuid) {
    const link: Link = {
      href: apiUrls.syncRelease
        .replace(':releaseGuid', releaseGuid)
        .replace(':versionGuid', versionGuid),
      method: 'POST',
    };

    return (
      <ContentContainer type={ContentContainerType.LIST} pt={6} flex={0}>
        <SlimBanner
          primaryText="Return to Release"
          onClick={() => {
            dispatch(
              syncVersionEffect({
                link,
                songGuid,
                versionGuid,
                releaseType: releaseType as ReleaseType,
              })
            );
            navigate(callback);
          }}
          onClose={() => navigate(pathname, { replace: true })}
        />
      </ContentContainer>
    );
  }

  return null;
};
